"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleButton = exports.MainContainer = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var polished_1 = require("polished");
var theme_1 = __importDefault(require("../../theme"));
var MainContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  background-color: ", ";\n  border-radius: 5px;\n  width: fit-content;\n  padding: 8px;\n  transition: all 0.3s;\n"], ["\n  display: flex;\n  align-items: center;\n  background-color: ", ";\n  border-radius: 5px;\n  width: fit-content;\n  padding: 8px;\n  transition: all 0.3s;\n"])), theme_1.default.colorsPalette.gray.superLight);
exports.MainContainer = MainContainer;
var ToggleButton = styled_components_1.default.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 8px 16px;\n  background-color: ", ";\n  color: ", ";\n  font-weight: ", ";\n  box-shadow: ", ";\n  border: none;\n  cursor: pointer;\n  outline: inherit;\n  border-radius: 5px;\n  transition: all 0.3s;\n\n  &:not(:last-child) {\n    margin-right: 8px;\n  }\n"], ["\n  padding: 8px 16px;\n  background-color: ", ";\n  color: ", ";\n  font-weight: ", ";\n  box-shadow: ", ";\n  border: none;\n  cursor: pointer;\n  outline: inherit;\n  border-radius: 5px;\n  transition: all 0.3s;\n\n  &:not(:last-child) {\n    margin-right: 8px;\n  }\n"])), function (_a) {
    var isSelected = _a.isSelected, customStyle = _a.customStyle;
    return isSelected
        ? (customStyle && customStyle.backgroundColor) ||
            theme_1.default.colorsPalette.white.default
        : "transparent";
}, function (_a) {
    var isSelected = _a.isSelected, customStyle = _a.customStyle;
    return isSelected
        ? (customStyle && customStyle.color) || theme_1.default.colorsPalette.gray.default
        : (customStyle && (0, polished_1.lighten)(0.7, customStyle.color)) ||
            theme_1.default.colorsPalette.gray.light;
}, theme_1.default.fontWeights.regular, function (_a) {
    var isSelected = _a.isSelected;
    return isSelected
        ? "0px 0px 7px 0px rgba(0, 0, 0, 0), 0 3px 5px 0px rgba(0, 0, 0, 0.03);"
        : "none";
});
exports.ToggleButton = ToggleButton;
var templateObject_1, templateObject_2;
//# sourceMappingURL=styles.js.map